/**
 * MonadMetaTags Component
 * Dynamically updates Open Graph and Twitter meta tags for monadmm.xyz domain
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const MonadMetaTags: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const hostname = window.location.hostname;
    const isMonadDomain = hostname === 'monadmm.xyz' || hostname === 'www.monadmm.xyz';

    if (isMonadDomain) {
      // Update or create meta tags for Monad
      const updateMetaTag = (property: string, content: string, isProperty = true) => {
        const selector = isProperty ? `meta[property="${property}"]` : `meta[name="${property}"]`;
        let meta = document.querySelector(selector) as HTMLMetaElement;
        
        if (!meta) {
          meta = document.createElement('meta');
          if (isProperty) {
            meta.setAttribute('property', property);
          } else {
            meta.setAttribute('name', property);
          }
          document.head.appendChild(meta);
        }
        meta.setAttribute('content', content);
      };

      // Check if we're on a token detail page
      const tokenMatch = location.pathname.match(/^\/monad\/token\/(0x[a-fA-F0-9]{40})$/);
      const isTokenPage = !!tokenMatch;
      const tokenAddress = tokenMatch ? tokenMatch[1] : null;

      if (isTokenPage && tokenAddress) {
        // Token detail page - use generic token page preview
        document.title = `Token on Monad Money Markets`;
        updateMetaTag('title', `Token on Monad Money Markets`, false);
        updateMetaTag('description', `View token details and trade on Monad Money Markets. Built by Mavrk.`, false);
        updateMetaTag('og:title', `Token on Monad Money Markets`);
        updateMetaTag('og:description', `View token details and trade on Monad Money Markets. Built by Mavrk.`);
        updateMetaTag('twitter:title', `Token on Monad Money Markets`);
        updateMetaTag('twitter:description', `View token details and trade on Monad Money Markets. Built by Mavrk.`);
      } else {
        // Main Monad page
        document.title = 'Monad Money Markets - Token Deployment on Monad';
        updateMetaTag('title', 'Monad Money Markets - Token Deployment on Monad', false);
        updateMetaTag('description', 'Deploy fully immutable token contracts on Monad. Built by Mavrk.', false);
        updateMetaTag('og:title', 'Monad Money Markets - Token Deployment on Monad');
        updateMetaTag('og:description', 'Deploy fully immutable token contracts on Monad. Built by Mavrk.');
        updateMetaTag('twitter:title', 'Monad Money Markets - Token Deployment on Monad');
        updateMetaTag('twitter:description', 'Deploy fully immutable token contracts on Monad. Built by Mavrk.');
      }

      // Common meta tags for all Monad pages
      updateMetaTag('og:type', 'website');
      updateMetaTag('og:site_name', 'Monad Money Markets');
      updateMetaTag('og:url', `https://${hostname}${location.pathname}`);
      updateMetaTag('og:image', `https://${hostname}/monad-og-image.png`);
      updateMetaTag('og:image:width', '1200');
      updateMetaTag('og:image:height', '630');

      updateMetaTag('twitter:card', 'summary_large_image');
      updateMetaTag('twitter:url', `https://${hostname}${location.pathname}`);
      updateMetaTag('twitter:image', `https://${hostname}/monad-og-image.png`);
    }
  }, [location.pathname]);

  return null; // This component doesn't render anything
};

export default MonadMetaTags;

